export const PROPERTY_TYPES = [
  "Appartement", "Atelier", "Boutique", "Box de stockage", "Bureau partagé", "Bureaux",
  "Caravane", "Cave", "Chalet", "Chambre", "Château", "Commerce", "Entrepôt", "Garage",
  "Grenier", "Hôtel Particulier", "Local professionnel", "Local commercial", "Loft",
  "Maison", "Mobil-Home", "Parking", "Studio", "Terrain", "Autre",
];

export const RENTAL_STATUSES = [
  "Disponible", "Loué", "Préavis / Départ", "Recherche de locataire", "Indisponible", "Travaux",
];

export const RENTAL_TYPES = [
  "Location meublée", "Location nue", "Location saisonnière",
];

export const ENERGY_CLASSES = ["A", "B", "C", "D", "E", "F", "G"];

export const COUNTRIES = [
  "France", "Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre",
  "Angola", "Anguilla", "Antarctique", "Antigua-et-Barbuda", "Antilles néerlandaises",
  "Arabie saoudite", "Argentine", "Arménie", "Aruba", "Australie", "Autre Océanie", "Autriche",
  "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Belgique", "Belize", "Benin",
  "Bermudes", "Bhoutan", "Bolivie", "Bosnie-Herzégovine", "Botswana", "British Antarctic Territory",
  "Brunei", "Brésil", "Bulgarie", "Burkina Faso", "Burundi", "Bélarus", "Cambodge", "Cameroun",
  "Canada", "Canton and Enderbury Islands", "Cap Vert", "Chili", "Chine", "Chypre", "Colombie",
  "Comores", "Congo", "Corée du Nord", "Corée du Sud", "Costa Rica", "Croatie", "Cuba",
  "Côte d’Ivoire", "Danemark", "Djibouti", "Dominique", "Dronning Maud Land", "El Salvador",
  "Espagne", "Estonie", "Fidji", "Finlande", "France", "French Southern and Antarctic Territories",
  "Gabon", "Gambie", "Ghana", "Gibraltar", "Grenade", "Groenland", "Grèce", "Guadeloupe", "Guam",
  "Guatemala", "Guinée", "Guinée équatoriale", "Guinée-Bissau", "Guyana", "Guyane française",
  "Géorgie", "Géorgie du Sud, Îles Sandwich du Sud", "Haïti", "Honduras", "Hong-Kong R.A.S. de Chine",
  "Hongrie", "Iles d’Åland", "Inde", "Indonésie", "Iran", "Iraq", "Irlande", "Islande", "Israël",
  "Italie", "Jamaïque", "Japon", "Johnston Island", "Jordanie", "Kazakhstan", "Kenya",
  "Kirghizistan", "Kiribati", "Kosovo", "Koweït", "Laos", "Lesotho", "Lettonie", "Liban", "Libye",
  "Libéria", "Liechtenstein", "Lithuanie", "Luxembourg", "Macao R.A.S. de Chine", "Macédoine",
  "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali", "Malte", "Maroc", "Martinique", "Maurice",
  "Mauritanie", "Mayotte", "Mexique", "Micronésie", "Midway Islands", "Moldova", "Monaco", "Mongolie",
  "Montserrat", "Monténégro", "Mozambique", "Myanmar", "Namibie", "Nauru", "Neutral Zone",
  "Nicaragua", "Niger", "Nigéria", "Niué", "Norvège", "Nouvelle-Calédonie", "Nouvelle-Zélande",
  "Népal", "Oman", "Ouganda", "Ouzbékistan", "Pacific Islands Trust Territory", "Pakistan", "Palaos",
  "Panama", "Panama Canal Zone", "Papouasie-Nouvelle-Guinée", "Paraguay", "Pays-Bas",
  "People's Democratic Republic of Yemen", "Philippines", "Pitcairn", "Pologne", "Polynésie française",
  "Porto Rico", "Portugal", "Pérou", "Qatar", "Roumanie", "Royaume-Uni", "Russie", "Rwanda",
  "République centrafricaine", "République dominicaine", "République démocratique du Congo",
  "République tchèque", "Réunion", "Sahara occidental", "Saint Kitts et Nevis", "Saint-Barthélemy",
  "Saint-Marin", "Saint-Martin", "Saint-Pierre-et-Miquelon", "Saint-Siège (Etat de la Cité du Vatican)",
  "Saint-Vincent-et-les Grenadines", "Sainte-Hélène", "Sainte-Lucie", "Samoa", "Samoa américaines",
  "Sao Tomé-et-Principe", "Serbie", "Seychelles", "Sierra Leone", "Singapour", "Sint Maarten",
  "Slovaquie", "Slovénie", "Somalie", "Soudan", "Sri Lanka", "Suisse", "Suriname", "Suède",
  "Svalbard et Île Jan Mayen", "Swaziland", "Syrie", "Sénégal", "Tadjikistan", "Tanzanie", "Taïwan",
  "Tchad", "Terres australes françaises", "Territoire britannique de l’océan indien",
  "Territoire palestinien", "Thaïlande", "Timor-Leste", "Togo", "Tokelau", "Tonga",
  "Trinité-et-Tobago", "Tunisie", "Turkmenistan", "Turquie", "Tuvalu",
  "U.S. Miscellaneous Pacific Islands", "Ukraine", "Uruguay", "Vanuatu", "Viet Nam", "Vénézuela",
  "Wake Island", "Wallis et Futuna", "Yémen", "Zambie", "Zimbabwe", "Égypte",
  "Émirats arabes unis", "Équateur", "Érythrée", "États-Unis", "Éthiopie", "Île Bouvet",
  "Île Christmas", "Île Norfolk", "Îles Caïmanes", "Îles Cocos", "Îles Cook",
  "Îles Falkland (Malvinas)", "Îles Féroé", "Îles Heard et MacDonald", "Îles Mariannes du Nord",
  "Îles Marshall", "Îles Mineures Éloignées des États-Unis", "Îles Salomon", "Îles Turks et Caïques",
  "Îles Vierges Britanniques", "Îles Vierges des États-Unis",
];
